// extracted by mini-css-extract-plugin
export var currentStep = "_g8-2";
export var nodeCard = "_g8-0";
export var pathHighlighted = "_g8-1";